import { useSelector } from 'react-redux';
import { State } from 'store/store';

export const useModuleVersionOnCreation = () => {
  const moduleVersionOnCreation = useSelector((state: State) => {
    return (
      state.rootBlockId &&
      (state.blocks[state.rootBlockId]?.meta as any)?.versionOnCreation
    );
  });

  //
  return moduleVersionOnCreation;
};
